import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import useFamilyBookPreload from '@/composables/preLoad/familyBook/useFamilyBookPreload.js'
import router from '@/router'

const fetchInfo = async () => {
  return await apiHelperService.get(`/api/individual/info`)
}
const fetchUsersInfo = async () => {
  const { query, params: routerParams } = router.currentRoute.value

  const params = {
    serviceTransId: routerParams.serviceId,
    IsUnifiedNumber: true,
    IdentityNumberOrUnifiedNumber: query.personUN
  }
  return await apiHelperService.get(`/api/individual/usersInfoByIdentityNumberOrUnifiedNumber`, {
    params
  })
}
const processDraft = () => {
  const formStore = useFormStore()

  if (formStore.draft.request.abroadDeathCountryId) {
    formStore.draft.request = {
      ...formStore.draft.request,
      placeOfDeath:
        formStore.draft.request.deathEmirateId || formStore.draft.request.deathCityId
          ? 1
          : formStore.draft.request.abroadDeathCountryId
            ? 2
            : 1
    }
  }
}

const initInfo = async () => {
  processDraft()
  const formStore = useFormStore()
  const res = await fetchInfo()
  const { familySequence, englishFullName, arabicFullName, identityNumber, passportNumber } = res

  formStore.form.setValues({
    applicantEngFullName: englishFullName,
    applicantArbFullName: arabicFullName,
    identityNumber: identityNumber,
    localPassportNumber: passportNumber,
    familyBooKFamilySequence: familySequence,
    abroadDeathCountryId: 1
  })
}

const initFillFamilyMemberInfo = async () => {
  const formStore = useFormStore()
  let response = {}
  try {
    if (query.personUN) {
      response = await fetchUsersInfo()
    }
  } catch (error) {
    console.error('initFillFamilyMemberInfo', error)
  }
  if (response?.numberOfRecords > 0) {
    const data = response?.collection[0]
    const {
      unifiedNumber,
      fatherArabicName,
      thirdArabicName,
      forthArabicName,
      fifthArabicName,
      firstArabicName,
      tribeArabicName,
      motherArabicName,
      motherFatherArabicName,
      fatherEnglishName,
      thirdEnglishName,
      forthEnglishName,
      fifthEnglishName,
      firstEnglishName,
      tribeEnglishName,
      motherEnglishName,
      motherFatherEnglishName,
      fullArabicName,
      fullEnglishName
    } = data
    formStore.draft.request = {
      ...formStore.draft.request,
      familyMemUnNumber: unifiedNumber,
      familyMemArbFatherName: fatherArabicName,
      familyMemArbThirdName: thirdArabicName,
      familyMemArbForthName: forthArabicName,
      familyMemArbFifthName: fifthArabicName,
      familyMemArbFirstName: firstArabicName,
      familyMemArbTribeName: tribeArabicName,
      familyMemArbMothName: motherArabicName,
      familyMemArbMothFathName: motherFatherArabicName,
      familyMemEngFatherName: fatherEnglishName,
      familyMemEngThirdName: thirdEnglishName,
      familyMemEngForthName: forthEnglishName,
      familyMemEngFifthName: fifthEnglishName,
      familyMemEngFirstName: firstEnglishName,
      familyMemEngTribeName: tribeEnglishName,
      familyMemEngMothName: motherEnglishName,
      familyMemEngMothFathName: motherFatherEnglishName,
      familyMemArbFullName: fullArabicName,
      familyMemEngFullName: fullEnglishName
    }
  }
}

export default async function () {
  try {
    await useFamilyBookPreload()
    await initInfo()
    await initFillFamilyMemberInfo()
  } catch (error) {
    console.error('use593Preload', error)
  }
}
